import { PayloadAction, createSlice } from '@reduxjs/toolkit';

export enum BannerType {
  FILE_UPLOAD = 'file_upload',
  FILE_UPLOADED = 'file_uploaded',
  FILE_ERROR = 'file_error',
}

interface BannerModel {
  message: string | null;
  type: BannerType | null;
  isShown: boolean;
}

const bannerSlice = createSlice({
  name: 'alert',
  initialState: { isShown: false, type: null, message: null } as BannerModel,
  reducers: {
    showBanner: (state, { payload }: PayloadAction<Omit<BannerModel, 'isShown'>>) => {
      state.type = payload.type;
      state.message = payload.message;
      state.isShown = true;
    },
    changeContent: (state, { payload }: PayloadAction<{ message: string }>) => {
      state.message = payload.message;
    },
    closeBanner: (state) => {
      state.type = null;
      state.message = null;
      state.isShown = false;
    },
  },
});

export const { showBanner, closeBanner, changeContent } = bannerSlice.actions;
export default bannerSlice.reducer;
